import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import fallback_img from "./img/fallback_img.jpg"
import loading_img from "./img/loadingImg.jpg"

import placeholderImg from "../img/thumbnailPlaceholder.png"
import { AlarmSmoke, BellElectric, BotMessageSquare, ChevronDown, ChevronRight, ChevronsLeftRightEllipsis, CornerDownRight, Heart, LayoutDashboard, LayoutGrid, LayoutPanelLeft, ListChecks, ListFilter, ListMusic, Minus, Pencil, Play, Plus, ShoppingCart, Trash2, X } from "lucide-react";
import ShowUpload from "../UI/ShowUpload";
import ShowSubCoursesInCourse from "./ShowSubCoursesInCourse";
import CourseCardAllInfoPage from "./CourseCardAllInfoPage";
const CourseCard1PopUp= ({appItem,item,setPopUpItem})=>{
    const dispatch = useDispatch();
           const user = useSelector((state)=>state?.user?.user);
     
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
 
      const [activeTab, setActiveTab] = useState("CourseInfo");
 
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
 
   
          const [reloadItems, setReloadItems] = useState(true);
       
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={``}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={``}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={``}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={``}
      />
    </div>
  );
};
return(<>
 <div     style={{zIndex:99,cursor:"pointer"}} onClick={()=>setPopUpItem()} className="CourseCard1PopUpOpacity"> </div>
     
<div className="CourseCard1PopUp">
  <div className="courseCard1OuterContainer" > <div className="courseCard1OuterContainerInn" >
     {item?.typeLabel?<div className="courseCardAllTypeLabel">{JSON.parse(item?.typeLabel)?.post_title}</div>:""}
  {item?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.statusLabel)?.post_title}</div>:""}

<div style={{width:"40px",height:"40px",cursor:"pointer",position:"absolute",
           borderRadius:"50%",right:"0px",margin:"2px",
         background:"#958FDA",zIndex:999999}} onClick={()=>setPopUpItem()}   >
           <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
   <ImageFallFB  itemOuter={{}}
                  boxShadow={``}
                  src={placeholderImg}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                    2/1.2
                  }
                  borderRadius={
                    {
                      value: 10,
                      resolution: "%",
                    }
                  }
                />     <div  className="courseCard1TopEditButtons"
><div  onClick={()=>{}}>
  <Link onClick={()=>{dispatch({
          type: "COURSEDATA",
          
          payload:item
        });
      
       dispatch({
      type: "APPDATA",
      
      payload:appItem
    }); 
    
      }} to={`/apps/${AppToken}/create/course-name`}>    <Pencil 
   strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222222" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
  
                   
                   </Link>
       </div> 
          
<Trash2  onClick={()=>{}}  strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222222" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> 
 </div>
                <div className="courseCard1MiddleButtons">
                     <div className="courseCard1MiddleButtons">
               {item?.languageLabel? <div className="courseCardAllLanguageLabel">{JSON.parse(item?.languageLabel)?.post_title}</div>:""}
              {item?.difficultyLabel?<div className="courseCardAllDifficultyLabel">{JSON.parse(item?.difficultyLabel)?.post_title}</div>:""}
             
              </div> 
              
                   <div className="courseCard1MiddleButtonsItem4 courseCard1MiddleButtonsItemTwo ">
                     <ChevronRight strokeWidth={1.75} size={20} color={"#777777"} /> </div> 
                     
                     </div>
                    
<div className="theme1  CoursePopUpCardTitle  "  style={{
                       borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:"#222"}}>
                       
                        {item?.productName}
                       </div>   <div className="coursePopUpInfoTabs">
             <div onClick={()=>{setActiveTab("CourseInfo")}} className={`coursePopUpInfoTabsInn ${activeTab=="CourseInfo"?"coursePopUpInfoTabsInnActive":""}`} > Course Information </div>
             <div  onClick={()=>{setActiveTab("SubCourses")}} className={`coursePopUpInfoTabsInn ${activeTab=="SubCourses"?"coursePopUpInfoTabsInnActive":""}`}> Sub-Courses </div>  </div>
         
                    {activeTab=="CourseInfo"?<> <CourseCardAllInfoPage  item={item} appItem={appItem} />     </>:""}
                       
                       </div></div>
                       <div className="courseCard1OuterPopUp" >
                   {activeTab=="SubCourses"?<><ShowSubCoursesInCourse item={item} appItem={appItem} /></>:""}
                   
</div></div>

</>)
}
export default CourseCard1PopUp;